import React, { Fragment } from 'react'
import { BsMouse, BsChevronDoubleDown } from 'react-icons/bs';
import {
    Row, Col
} from 'react-bootstrap';
import {
    Link
} from "react-router-dom";
import { IconContext } from 'react-icons';
import { FaExternalLinkAlt } from 'react-icons/fa';

export const LandingPage = () => {

    return (
        <Fragment>
            <div className="landing" style={{ "width": "100%" }}>
                <div style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    height: 50,
                    padding: 10,
                    paddingRight: 20,
                    gap: 10
                }} className='d-flex flex-row flex-wrap'>

                    <Link className="custom-link" style={{ width: 100, textAlign: 'right' }} to='/'>Home</Link>
                    <Link className="custom-link" style={{ width: 170, textAlign: 'right' }} to='https://waterborne.eu/projects/coordination-projects/needs/documents'>Project deliverables <FaExternalLinkAlt size={'0.7em'}/></Link>

                    <Link className="custom-link" style={{ width: 100, textAlign: 'right' }} to='/dashboard'>Dashboard</Link>

                </div>

                <div style={{
                    position: 'absolute',
                    top: 10,
                    left: 0,
                    height: "200px",
                    maxHeight: "20vh",
                    paddingLeft: 20,
                }}>
                    <img src="/needs_logo.png" alt="NEEDS Logo" height="200px" style={{ maxHeight: '20vh' }} />
                </div>

                <Row className="align-items-center" style={{ "height": "100vh", "margin": 0 }}>
                    <Col className="text-center">
                        <h1 style={{ color: "white", textWrap: "balance" }}>NEEDS: A Dynamic Techno-Economical Scenario Simulation Model for Sustainable Waterborne Activities and Transport</h1>
                        <IconContext.Provider value={{ color: "white", size: "2em" }} >
                            <div className="stuiteren">

                                <BsMouse /><BsChevronDoubleDown />
                            </div>
                        </IconContext.Provider>
                    </Col>
                </Row>
                <Row className="justify-content-center" style={{ color: 'white', margin: 0 }}>
                    <Col md={10} sm={11} lg={9}>
                        <p>NEEDS stands for NEw sustainablE fuel Deployment Scenarios for the European waterborne community. The main objective of NEEDS is to provide a model and methodology to define and assess the most efficient strategies to be deployed for successfully reaching the European target of 90% GHG reduction for waterborne activities by 2050, for selected regions.</p>
                        <p>The project, financed by the European Commission, has the following members:</p>

                        <img src="/ProjectIdentity.PNG" alt="Project members" className="landingPageImg" />

                        <p>A  dynamic  techno-economic  model  developed in this project supports  such  an  objective.  It  can  allow  policy  makers,  regional  and  national authorities, ship and fleet owners, as well as any other interested public or private entity to define the specificity of a given maritime or inland waterways region, vary selected governing parameters and launch scenarios that can illustrate the dynamic of changes over time.</p>
                        <p>The model includes the following main generic elements, forming a complete waterborne transport eco-system for a (to be defined) region:</p>
                        <ul>
                            <li>Energy (existing energy supply and potential future alternative sustainable energy carriers)</li>
                            <li>Harbour infrastructure (energy bunkering, charging or swapping and shipping logistics);</li>
                            <li>Waterborne transport (ships, trade routes and transport capacity).</li>
                            <li>Environmental conditions thought hindcast data (current, water depth, waves and wind)</li>
                        </ul>

                        <img src="/FrameworkWithElements.png" alt="Framework" className="landingPageImg" />

                        <p>In order to illustrate the possibilities of such model, 2 regions were selected for which results are so far made publicly available in the Dashboard section of this portal. The Rhine region was covered as well as the Greek inter-island network.</p>

                        <img src="/RegionsSimulated.png" alt="Regions" className="landingPageImg" />

                        <p>For each region, a dedicated analysis and representation of the fleet and infrastructure was realised, including governing parameters and their possible inter-dependency, as well as current ships performance and alternative ships or power system for refit strategies.</p>
                        <p>The large amount of variables and the possibility to change them in time allows for an almost infinite number of scenarios. The scenario’s presented on this portal were prepared by the project members, but can still be developed further and adapted to new insights or ideas of scenarios.</p>
                        <p>The current project ends in October 2023 but preparations to create a user-group with interested parties and keep developing NEEDS are underway. A workshop to present the results and identify possible interested parties is planned current September (preliminary date in September 13th, which will be confirmed soon).</p>
                        <p>All project deliverables can be found on the website of <Link to='https://waterborne.eu/projects/coordination-projects/needs/documents'>Waterborne</Link>.</p>
                    </Col>

                </Row>
                {/* <Row style={{ "height": "9vh", "margin": 0 }} /> */}
                <Row style={{ "height": "15vh", "margin": 0, minHeight: 40 }}>
                    <Col className="d-flex align-items-end">
                        <img src="/Europe.png" alt="EU Flag" style={{ maxWidth: '90vw', maxHeight: 40, aspectRatio: '87 / 8', marginBottom: 10 }} />
                    </Col>
                </Row>
            </div>
        </Fragment >
    )


}